import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { autoUnsubWith, Utility } from '../../services/utility.abstract';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { CompanyService, BreadcrumbItem } from '../../services/company.service';
import { ToastService } from '../../services/toast.service';
import { DriverService } from '@core/services/driver.service';
import { Location } from '@angular/common';
import { MenuService } from '@core/services/menu.service';
import { CommonFunctions } from '@shared/common-functions';
import { CommonMenuService } from '@shared/services/common-util.service';
import { DriverService  as SharedDriverService} from '@shared/components/driver/services/driver.service';
import { InvoicePaymentStatus, PaymentMode } from '@core/models/api-response.model';
import { CancelModalComponent } from '../cancel-modal/cancel-modal.component';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { InvoiceType } from '../custom-invoice/custom-invoice.component';
import { CANCEL_INVOICE_CONFIRMATION_MODEL, itemsPerPageList, MARK_AS_PAID_CONFIRMATION, PAYMENT_MODE, USER_TYPE } from '@shared/constant/shared.constant';
import { ItemPerPage } from '@core/models/file-response.model';
import { ReloadService } from '@shared/services/reload.service';
import { PayRepayModalComponent } from '../pay-repay-modal/pay-repay-modal.component';
import { SuperAdminService } from '@core/services/super-admin.service';
import { SharedInvoicePopupComponent } from '../shared-invoice-popup/shared-invoice-popup.component';
import { Router } from '@angular/router';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';
@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.scss'],
})
export class InvoiceListComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  invoiceList: any;
  itemsPerPage: number = 10;
  totalRecords: number;
  currentSkip: number = 0;
  currentPageUpcoming: number = 1;
  name: string;
  email: string;
  phoneNumber: any;
  invoiceNumber: string;
  selectDriverStatus: any;
  CustomItemPerPageBy: ItemPerPage[] = itemsPerPageList;
  items: MenuItem[] | undefined;
  SearchItemPerPageBy: any;
  dummy: string = '../../../../assets/images/dummy-img.png';
  activeItem: any;
  excelFile:any;
  invoiceListRequest: any;
  goToCurrentTab: boolean = false;
  showInput: boolean = false;
  role: string = '';
  roleRoute: string = '';
  searchStatus: number = null;
  selectStatus: { name: string; value: number }[] = [];
  chackFilterType: boolean = false;
  companyId: string = '';
  createInvoiceCheck: boolean = false;
  invoicePaymentStatus = InvoicePaymentStatus;
  isAlternateDesign: boolean = false;
  reloadSubscription: any;
  userType = USER_TYPE
  
  constructor(
    private readonly driverService: DriverService,
    private readonly sharedDriverService: SharedDriverService,
    private readonly toastService: ToastService, 
    private readonly companyService: CompanyService,
    private readonly menuService: MenuService,
    private readonly location: Location,
    private readonly commonMenuService: CommonMenuService,
    private readonly dialogControlService: DialogControlService,
    private readonly reloadService: ReloadService,
    private readonly superAdminService: SuperAdminService,
    private readonly  confirmationService: ConfirmationService,
     private readonly router: Router,
     private readonly encryptStorage: EncryptionStorageService
  ) {
    this.role = this.encryptStorage.getItem('roleName');
    this.roleRoute = CommonFunctions.routeToBookingDetail(this.role);
  }

  ngOnInit() {
    (this.createInvoiceCheck = this.menuService.shortNameExists(
      JSON.parse(this.encryptStorage.getItem('menuData')),
      85
    )),
      this.selectStatus = [
        { name: 'All', value: null },
        { name: 'Paid', value: 1 },
        { name: 'Pending', value: 0 },
        { name: 'In-Process', value: 3 },
        {name: 'Cancelled', value: 4 },
        { name: 'Payment Failed', value: 2 },
      ];
      this.superAdminService.popupClosed$.subscribe(refresh => {
        if (refresh) {
          this.getParkingLotInvoiceForDriver('firsttime');
        }
      });
    this.getParkingLotInvoiceForDriver('firsttime'); 
    const breadcrumbObj: BreadcrumbItem[] = [
      {
        title: ' Manage Invoices',
      },
      {
        title: 'Invoice List',
      },
    ];

    this.companyService.setAdminHeaders('0', breadcrumbObj);
    this.goToTop();
    this.companyId = this.encryptStorage.getItem('companyId');
    this.reloadSubscription = this.reloadService.reload$.subscribe(() => {
      this.getParkingLotInvoiceForDriver('search');
    });
  }

  exportMenu() {
    this.isAlternateDesign = false;
    this.items = [
      {
        items: [
          {
            label: 'Export',
            icon: 'pi pi-download',
            command: () => {
              this.getParkingLotInvoiceForDriver('export');
            }
          },
        ]
      },
    ];

  }

    get isAdminOrOwnerRole(): boolean {
    return CommonFunctions.isAdminOrOwnerRole(this.role);
  }

    goToCrmPage(rowData: any) {
  const isGroupOperator = rowData?.userType === this.userType.GROUP_OPERATOR;

  const page = isGroupOperator ? 'group-operator-info' : 'driver-info';
  const queryParam = isGroupOperator ? 'Id' : 'id';

  CommonFunctions.navigateToCRM(
    this.roleRoute,
    rowData.driverId,
    this.router,
    this.sharedDriverService,
    page,
    queryParam,
    '0'
  );
}

  getParkingLotInvoiceForDriver(changeAction) {
    
    let defaultRequest = {
      name: this.name || '',
      phoneNumber: this.phoneNumber || '',
      driverEmail: this.email || '',
      invoiceNumber: this.invoiceNumber || '',
      paymentStatus : this.searchStatus,
      timeZone: Utility.getLocalTimeZone(),
    };
    let pageNumber: number;
    let pageSize: number;

    switch (changeAction) {
      case 'reset':
        pageNumber = 1;
        pageSize = this.itemsPerPage;
        break;
      case 'search':
        pageNumber = 1;
        pageSize = this.itemsPerPage;
        break;
      case 'export':
        pageNumber = 0;
        pageSize = 0;
        break;
      default:
        pageNumber = this.currentPageUpcoming;
        pageSize = this.itemsPerPage;
        break;
    }
    this.invoiceListRequest = {
      ...defaultRequest,
      pageNumber,
      pageSize,
    };

    this.driverService
      .getParkingLotInvoiceForDriver(this.invoiceListRequest)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (response) => {
          if (changeAction === 'search') {
            this.currentSkip = 0;
            CommonFunctions.scrollTopRow('top');
          }
          if (changeAction === 'export') {
            this.excelFile = response.data;
            this.export();
            
            return
          }
          this.totalRecords = response.totalRecords;
          this.invoiceList = response.data;
          this.excelFile = this.invoiceList;
          
        },
        error: (_error) => {
          this.currentSkip = 0;
          this.invoiceList = [];
        },
      });
  }

  onPageChange(event: any) {
    this.currentSkip = event.first;
    this.currentPageUpcoming = event.page + 1;
    CommonFunctions.scrollTopRow('top');
    this.getParkingLotInvoiceForDriver('pageChange');
  }

  onDropdownChange(event: any) {
    this.itemsPerPage = event.value;
    this.currentSkip = 1;
    this.currentPageUpcoming = 1;
    CommonFunctions.scrollTopRow('top');
    this.getParkingLotInvoiceForDriver('dropdownchange');
  }

  onChangePaymentStatus(event: any) {
    this.searchStatus = event.value;
  }

  getFlagClass(iso: string): string {
    const lowerCaseIso = iso?.toLowerCase();
    return `fi fi-${lowerCaseIso}`;
  }

  resetFilter() {
    this.name = '';
    this.email = '';
    this.invoiceNumber = '';
    this.currentPageUpcoming = 1;
    this.itemsPerPage = 10;
    this.currentSkip = 0;
    this.phoneNumber = '';
    this.SearchItemPerPageBy = null;
    this.searchStatus = null;
    this.getParkingLotInvoiceForDriver('reset');
    this.goToTop();
  }

  goToTop() {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    });
  }

  openCancelModal(bookindId) {
    this.dialogControlService.openDialog(CancelModalComponent, {
      width: '20%',
      data: {
        comingFromInvoice: true,
        invoiceId: bookindId,
        headerText: "Cancel",
        bodyText: CANCEL_INVOICE_CONFIRMATION_MODEL,
      }
    });
    this.dialogControlService.onClose().subscribe((result) => {
      if(result.status){
        this.getParkingLotInvoiceForDriver('firsttime');
      };
    });
  }
  
  markAsPaidFunc(invoiceId: string) {
    let request = {
      invoiceId: invoiceId,
      timeZone: Utility.getLocalTimeZone(),
    };
    this.sharedDriverService.createInvoicePaymentOffline(request)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (_response: any) => {
        this.getParkingLotInvoiceForDriver('firsttime');
        this.toastService.showToastMessage(
          'success',
          'Success',
          'Custom invoice has been marked as paid.'
        ); 
      },
      error: (error) => {
        this.toastService.showToastMessage(
          'error',
          'Error',
          error?.error?.message
        ); 
      },
    });
  }

showData(rowData: any, event: any) {
    this.isAlternateDesign = true;
    const actionMap = {
      viewInvoice: () => this.downloadInvoice(rowData.id),
      pay: () => {
        this.dialogControlService.openDialog(PayRepayModalComponent, {
          styleClass: 'pay-repay',
          data: {
            id: null,
            invoiceId:rowData.id,
            driverId:rowData.driverId,
            bookingType:false
          },
        });
        this.dialogControlService.onClose().subscribe(() => {
          this.getParkingLotInvoiceForDriver('search');
        });
      },
      customCancel: () => {
        this.openCancelModal(rowData.id);
      },
      markAsPaid: (product, event) => {
        this.confirmationService.confirm({
          target: event.target as EventTarget,
          message: MARK_AS_PAID_CONFIRMATION,
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.markAsPaidFunc(product?.id);
          },
        });
      },
    };

    const config = [
      {
        label: '',
        icon: '',
      },
      {
        label: 'Share Invoice',
        icon: 'common-icon share-invoice',
        escape: false,
        command: () => {
          this.dialogControlService.openDialog(SharedInvoicePopupComponent, {
            styleClass: 'shareinvoice-model',
            data: {
              invoiceId: rowData.id,
              email: rowData?.email,
              mobileNumber: rowData?.phoneNumber ? rowData?.countryCode + ' ' + rowData?.phoneNumber : null,
              isBookingExist: false
            },
          });
        },
      },
      {
        label: 'View Invoice',
        icon: 'common-icon view-profile',
        escape: false,
        command: actionMap.viewInvoice,
      },
      {
        label:  rowData?.paymentStatus === this.invoicePaymentStatus.PaymentFailed ? 'Re-Pay': 'Pay',
        icon: 'common-icon custom-pay',
        visible: rowData.status === 'Pending' ||  rowData?.paymentStatus === this.invoicePaymentStatus.PaymentFailed,
        command: actionMap.pay
      },
      {
        label: 'Mark as Paid',
        icon: 'common-icon mark-as-paid',
        escape: false,
        visible: (rowData?.paymentStatus === this.invoicePaymentStatus.PaymentFailed || rowData?.paymentStatus === this.invoicePaymentStatus.Pending || rowData?.paymentStatus === this.invoicePaymentStatus.CheckoutUrlGenrated),
        command: () => actionMap.markAsPaid(rowData, event),
      },
      {
        label: 'Cancel',
        icon: 'pi pi-times',
        escape: false,
        visible: !(rowData?.paymentStatus == this.invoicePaymentStatus.Paid || rowData?.paymentStatus == this.invoicePaymentStatus.Cancel || rowData?.paymentStatus == this.invoicePaymentStatus.InProgress),
        command:actionMap.customCancel,
        },
    ];
    this.items = this.commonMenuService.commonShowData(config);
  }

  downloadInvoice(id) {
    const req = {
      InvoiceType: InvoiceType.OneTimeInvoice,
      id: id
    };

    this.driverService
      .downloadInvoice(req)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (_response) => {
          const url = _response.data as string;
          window.open(url, '_blank');
        },
        error: (er: Error) => {
          this.toastService.showToastMessage('error', 'Error', er.message);
        },
      });
  }

  onlyNumber(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }
    getTimeZoneAbbreviation(timeZone: string): string {
    return CommonFunctions.getTimeZoneAbbreviation(timeZone);
  }

  backRoute() {
    this.location.back();
  }

  export() {
    if (this.excelFile) {
      const headers = [
        { header: 'S. No.', key: 'index', formatter: (value) => value + 1 },
        { header: 'Name', key: 'userType', formatter: (_value, item) => item.userType === 'Group Operator' ? item.groupName : item.name },
        { header: 'Invoice Number', key: 'invoiceNumber' },
        { header: 'Email', key: 'email' },
        { header: 'Mobile Number', key: 'phoneNumber', formatter: (_value, item) => `${item.countryCode}${item.phoneNumber}` },
        { header: 'User Type', key: 'userType' },
        { header: 'Company', key: 'company' },
        { header: 'Parking Lot', key: 'parkingLotName' },
        { header: 'Time Zone', key: 'timeZone', formatter: (value) => value ? this.getTimeZoneAbbreviation(value) : '-' },
        { header: 'Address', key: 'address' },
        { header: 'Generated By', key: 'generatedBy' },
        { header: 'Invoice Date', key: 'billingDate' },
        { header: 'Created Date', key: 'dateCreated' },
        { header: 'Amount ($)', key: 'totalAmount' },
        { header: 'Payment Mode', key: 'bookingPaymentMode', formatter: (value) => value === PaymentMode.Online ? PAYMENT_MODE.ONLINE : value === PaymentMode.Offline ? PAYMENT_MODE.OFFLINE : '', },
        { header: 'Payment Status', key: 'status' },

      ]

      const dataWithIndex = this.excelFile.map((item, index) => ({
        ...item,
        index, // Add the index to each row
      }));

      return CommonFunctions.exportToExcel(dataWithIndex, headers, 'Custom Invoice List_')
    }
  }

  formatDateAndTime(inputDate) {
    const date = new Date(inputDate);
    const monthAbbreviation = new Intl.DateTimeFormat('en-US', {
      month: 'short',
    }).format(date);
    const day = date.getDate();
    const year = date.getFullYear();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const formattedDay = String(day).padStart(2, '0');
    const formattedHour = String(hour).padStart(2, '0');
    const formattedMinute = String(minute).padStart(2, '0');
    const formattedDate = `${monthAbbreviation} ${formattedDay}, ${year} - ${formattedHour}:${formattedMinute}`;
    return formattedDate;
  }
}
